export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_KEY = process.env.X_API_KEY;
export const DAY_MS = 24 * 60 * 60 * 1000;

// src/constants/marketHolidays.js
export const INDIAN_HOLIDAYS = [
  "2026-01-26", // Republic Day
  "2026-03-06", // Holi
  "2026-03-27", // Id-ul-Fitr
  "2026-04-03", // Mahavir Jayanti / Good Friday
  "2026-04-14", // Dr. Baba Saheb Ambedkar Jayanti
  "2026-05-01", // Maharashtra Day
  "2026-08-28", // Id-e-Milad
  "2026-10-02", // Mahatma Gandhi Jayanti
  "2026-10-20", // Dussehra
  "2026-11-05", // Diwali Laxmi Pujan
  "2026-11-06", // Diwali Balipratipada
  "2026-11-24", // Guru Nanak Jayanti
  "2026-12-25", // Christmas
];

export const AIRLINE_CODE = Object.freeze({
  VF: "Air France",
  VY: "Vueling Airlines",
  W6: "Wizz Air",
  "6E": "IndiGo",
  AI: "Air India",
  G8: "GoAir",
  I5: "InterGlobe Aviation",
  SG: "SpiceJet",
  UK: "Air UK",
  ZE: "Air Arabia",
  ZY: "Air Zermatt",
  WN: "Southwest Airlines",
  Y8: "Air Arabia Egypt",
  Y9: "Air Arabia Jordan",
  YT: "Air Tahiti Nui",
  YZ: "Air Zermatt",
  ZH: "Air China",
  ZX: "Air China Express",
  ZZ: "Air Zermatt",
  IX: "Air India Express",
  MH: "Malaysia Airlines",
  TG: "Thai Airways International",
  QR: "Qatar Airways",
  TR: "Tiger Airways",
  HU: "Hainan Airlines",
  BS: "US-Bangla Airlines",
  CX: "Cathay Pacific",
  EK: "Emirates",
  EY: "Etihad Airways",
  H1: "Hahnair Systems",
  GP: "APG Airlines",
  G9: "Air Arabia",
});

export const CURRENCY_CODE = Object.freeze({
  EUR: "€",
  GBP: "£",
  AED: "د.إ",
  INR: "₹",
  USD: "$",
  JPY: "¥",
  CNY: "¥",
  BRL: "R$",
  VND: "₫",
});

export const CABIN_PREFERENCE = Object.freeze({
  Y: "Economy",
  C: "Business",
  F: "First",
  S: "Premium Economy",
});

export const REFUND_STATUS = Object.freeze({
  not_applicable: "N/A",
  pending: "PENDING",
  completed: "COMPLETED",
  failed: "FAILED",
  rejected: "REJECTED",
});

export const BOOKING_PAGE_TYPE = Object.freeze({
  VIEW: "view",
  EDIT: "edit",
  REFUND: "refund",
});

export const HOTEL_BOOKING_STATUS = Object.freeze({
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  CANCELLED: "CANCELLED",
});

export const FLIGHT_BOOKING_STATUS = Object.freeze({
  BOOKED: "Booked",
  PENDING: "Pending",
  CANCELLED: "Cancelled",
});

export const ENTITY_TYPES = ["All", "User", "Broker", "SubAdmin", "Admin"];

export const PENDING_ORDER_RULES = [
  { value: "off", label: "Off" },
  { value: "outside_high_low", label: "Outside High-Low" },
  { value: "inside_high_low", label: "Inside High-Low" },
];

export const TRADING_SEGMENTS = [
  "NFO-FUT",
  "MCX-FUT",
  "INDICES-FUT",
  "COMEX",
  "FOREX",
  "CRYPTO",
  "US-EQUITY",
];

export const COMMON_SCRIPTS = [
  "CRUDEOIL",
  "GOLD",
  "SILVER",
  "NIFTY",
  "BANKNIFTY",
  "NATURALGAS",
];
